import { Touchpoint } from '../../ScriptingEngineEnvironment';

export class UIDocumentControllerTouchPoint implements Touchpoint.UIDocumentController.IUIDocumentControllerTouchPoint {
    register(): void {
        // we currently do not extract any metadata about controller function registrations.
    }
}
